import React from "react";

/**
 * @deprecated You should be passed the patient id from your parent or your
 * routing.
 */
interface PatientContextType {
  uuid: string;
}

/**
 * @deprecated You should be passed the patient id from your parent or your
 * routing.
 */
export const PatientContext = React.createContext<PatientContextType | null>(
  null,
);

/**
 * @deprecated You should be passed the patient id from your parent or your
 * routing.
 */
export const usePatientContext = () => React.useContext(PatientContext);
